import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  LECTURE_CONTENT_TYPES,
  lectureContentsSelector,
  setLiteratureResource,
  setPostLectureContent,
  setPreLectureContent,
} from 'features/classCreation';
import ToggleChip from 'components/ToggleChip';

export default function LectureContentChip({ contentType, title }) {
  const dispatch = useDispatch();
  const lectureContents = useSelector(lectureContentsSelector);

  const handleAddLectureContent = useCallback(() => {
    switch (contentType) {
      case LECTURE_CONTENT_TYPES.preLecture:
        dispatch(setPreLectureContent({ content_type: contentType }));
        break;
      case LECTURE_CONTENT_TYPES.postLecture:
        dispatch(setPostLectureContent({ content_type: contentType }));
        break;
      case LECTURE_CONTENT_TYPES.literatureResource:
        dispatch(setLiteratureResource({ content_type: contentType }));
        break;
      default:
        return null;
    }
  }, [contentType, dispatch]);

  const handleRemoveLectureContent = useCallback(() => {
    switch (contentType) {
      case LECTURE_CONTENT_TYPES.preLecture:
        dispatch(setPreLectureContent(null));
        break;
      case LECTURE_CONTENT_TYPES.postLecture:
        dispatch(setPostLectureContent(null));
        break;
      case LECTURE_CONTENT_TYPES.literatureResource:
        dispatch(setLiteratureResource(null));
        break;
      default:
        return null;
    }
  }, [contentType, dispatch]);

  return (
    <ToggleChip
      isAdded={Boolean(lectureContents[contentType])}
      onAdd={handleAddLectureContent}
      onRemove={handleRemoveLectureContent}
      label={title}
      className="m-r-xs m-b-xxs"
    />
  );
}
